const memoryStorage = new Map();

const browserStorages = () => {
  if (typeof window === 'undefined') return [];
  const storages = [];
  try { if (window.localStorage) storages.push(window.localStorage); } catch (error) { /* stockage privé indisponible */ }
  try { if (window.sessionStorage) storages.push(window.sessionStorage); } catch (error) { /* stockage privé indisponible */ }
  return storages;
};

export function readAuthStorage(key) {
  for (const storage of browserStorages()) {
    try {
      const value = storage.getItem(key);
      if (value !== null) return value;
    } catch (error) {
      // Essayer le stockage suivant.
    }
  }
  return memoryStorage.get(key) ?? null;
}

export function writeAuthStorage(key, value) {
  for (const storage of browserStorages()) {
    try {
      storage.setItem(key, value);
      memoryStorage.delete(key);
      return;
    } catch (error) {
      // Essayer le stockage suivant.
    }
  }
  memoryStorage.set(key, value);
}

export function removeAuthStorage(key) {
  memoryStorage.delete(key);
  for (const storage of browserStorages()) {
    try { storage.removeItem(key); } catch (error) { /* rien à nettoyer */ }
  }
}
